const icon = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<title>Business Ads</title>
		<path
			fill="#ffffff"
			d="M19.5,4.5H2.5a1,1,0,0,0-1,1v12a1,1,0,0,0,1,1h17a1,1,0,0,0,1-1V5.5A1,1,0,0,0,19.5,4.5Z"
		/>
		<path
			fill="#3690FF"
			d="M20.5,5.5v3H1.5v-3a1,1,0,0,1,1-1h17A1,1,0,0,1,20.5,5.5Z"
		/>
		<path
			fill="#111111"
			d="M12.5,19H2.5A1.5,1.5,0,0,1,1,17.5V5.5A1.5,1.5,0,0,1,2.5,4h17A1.5,1.5,0,0,1,21,5.5v4a.5.5,0,1,1-1,0v-4a.5.5,0,0,0-.5-.5H2.5a.5.5,0,0,0-.5.5v12a.5.5,0,0,0,.5.5h10a.5.5,0,0,1,0,1Z"
		/>
		<path
			fill="#111111"
			d="M20.5,9H1.5a.5.5,0,0,1,0-1h19a.5.5,0,0,1,0,1ZM14,6.5a.5.5,0,1,1,.5.5.5.5,0,0,1-.5-.5m2,0a.5.5,0,1,1,.5.5.5.5,0,0,1-.5-.5m2,0a.5.5,0,1,1,.5.5.5.5,0,0,1-.5-.5"
		/>
		<path fill="#3690FF" d="M22.5,14H20l1.83-2.5H18L15.25,15h2L15,19.5Z" />
		<path
			fill="#000000"
			d="M15,20a.5.5,0,0,1-.45-.72l1.87-3.78H15.25a.5.5,0,0,1-.39-.81l2.75-3.5A.5.5,0,0,1,18,11h3.88a.5.5,0,0,1,.4.8L21,13.5H22.5a.5.5,0,0,1,.3.9l-7.5,5.5A.5.5,0,0,1,15,20Zm1.28-5.5h1a.5.5,0,0,1,.45.72l-1.32,2.66L21,14.5H20a.5.5,0,0,1-.4-.8L20.89,12H18.24l-2,2.5Z"
		/>
		<path
			fill="#cccccc"
			d="M12,13.5H4.5a1,1,0,0,1-1-1v-1a1,1,0,0,1,1-1H12a1,1,0,0,1,1,1v1A1,1,0,0,1,12,13.5Zm-2.5,2h-1a.5.5,0,0,1,0-1h1a.5.5,0,0,1,0,1Zm-3,0h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z"
		/>
		<path
			fill="#111111"
			d="M19.5,19a.5.5,0,1,1,0-1,.5.5,0,0,0,.5-.5.5.5,0,0,1,1,0A1.5,1.5,0,0,1,19.5,19Z"
		/>
	</svg>
);

export default icon;
